(function () {
  function initializeVideoPlayBtn() {
    const playButton = document.querySelector(".product-video-mp4-btn");
    const video = document.querySelector(".product__video");

    if (playButton) {
      // Add an event listener to the button
      playButton.addEventListener("click", () => {
        console.log("playButton listener");
        playButton.classList.add("hide");

        // Add the 'controls' attribute to the video
        video.setAttribute("controls", true);

        // Play the video
        video.play();
      });
    }
  }
  initializeVideoPlayBtn();

  // Define the media query breakpoint (e.g., 768px for mobile view)
  const responsiveBreakpoint = window.matchMedia("(max-width: 768px)");
  const headerLayout = document.querySelector(".header-layout");
  const initialLogoAlign = headerLayout.getAttribute("data-logo-align");

  // Query elements once
  const headerNavigation = document.querySelector(
    ".header-item--navigation:not(.header-compact)"
  );
  const headerLogo = document.querySelector(
    ".header-item--logo:not(.header-compact)"
  );
  const headerNavigationCompact = document.querySelector(
    ".header-item--navigation.header-compact"
  );
  const headerLogoCompact = document.querySelector(
    ".header-item--logo.header-compact"
  );
  const navigationDrawer = document.querySelector(
    ".header-item--icons button.js-drawer-open-nav"
  );
  const wishlist = document.querySelector(".site-nav__link--icon.wishlist");

  // Function to toggle display styles based on view
  function toggleDisplay(elements, displayValue) {
    elements.forEach((element) => {
      if (element) element.style.display = displayValue;
    });
  }

  // Function to handle responsive view changes
  function handleResponsiveChange(e) {
    if (e.matches && headerNavigationCompact) {
      // Responsive view: Show compact, hide regular elements
      toggleDisplay(
        [headerNavigation, headerLogo, navigationDrawer, wishlist],
        "none"
      );
      toggleDisplay([headerNavigationCompact, headerLogoCompact], "flex");
      headerLayout.setAttribute("data-logo-align", "center");
    } else {
      // Desktop view: Show regular, hide compact elements
      toggleDisplay([headerNavigation, headerLogo], "flex");
      toggleDisplay([headerNavigationCompact, headerLogoCompact], "none");
      navigationDrawer && (navigationDrawer.style.display = "block");
      wishlist && (wishlist.style.display = "inline-block");
      headerLayout.setAttribute("data-logo-align", initialLogoAlign);
    }
  }

  // Add event listener for breakpoint changes
  responsiveBreakpoint.addEventListener("change", handleResponsiveChange);

  // Initial check for when the page loads
  handleResponsiveChange(responsiveBreakpoint);
})();
